
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlAe as ObiOwnShipControlAeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-ae.js';
 
 
 

 
 export const ObiOwnShipControlAe = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-ae',
   elementClass: ObiOwnShipControlAeElement,
   events: {
     
   }
  });
 
 